export default {
  'search.placeholder': 'Buscar por nombre, lugar, servicios...',
  'search.results': '{{count}} perfiles',
  'search.no_results': 'No se encontraron resultados para "{{query}}"',
  'search.clear': 'Limpiar búsqueda',
  'search.showing': 'Mostrando',
  'search.showing_results': 'Resultados para "{{query}}"',
  'search.showing_all': 'Mostrando todos los perfiles',
  'search.results_for': 'resultados para',
  'search.and': 'y',
  'search.with_filters': 'con {{count}} filtros activos',
  'search.active_filters': 'filtros activos',
  'search.no_profiles_found': 'No se encontraron perfiles',
  'search.no_profiles_message': 'No pudimos encontrar ningún perfil en este momento. Por favor, inténtalo de nuevo más tarde o ajusta tus criterios de búsqueda.',
  'search.try_again': 'Por favor, intenta con otro término de búsqueda o explora todos los perfiles.',

  // New keys to ensure everything is translated
  'filters.from': 'Desde',
  'filters.to': 'Hasta',
  'profile.verified': 'Verificado',
  'profile.online': 'En línea',
  'profile.years': 'años',
  'profile.touring': 'De gira',
  'profile.favorite': 'Añadir a favoritos',
  'profile.unfavorite': 'Quitar de favoritos',
  'profile.message': 'Mensaje',
  'profile.tabs.about': 'Acerca de',
  'profile.tabs.services': 'Servicios',
  'profile.tabs.rates': 'Tarifas',
  'profile.tabs.contact': 'Contacto',
  'profile.services': 'Servicios ofrecidos',
  'profile.rates': 'Tarifas',
  'profile.contact': 'Información de contacto',
  'profile.no_services': 'No hay servicios listados',
  'profile.no_rates': 'No hay tarifas listadas',
  'profile.generating_image': 'Generando imagen...',
  'profile.various_durations': 'Varias duraciones',

  // New keys from logs
  'search.filter_results': 'Filtrar Resultados',
  'search.reset_filters': 'Restablecer Filtros',
  'search.all_genders': 'Todos los Géneros',
  'search.min_age': 'Edad Mín',
  'search.max_age': 'Edad Máx',
  'search.status': 'Estado',
  'search.verified_only': 'Solo Verificados',
  'search.online_only': 'Solo En Línea',

  // Keys from logs
  'search.search_placeholder': 'Buscar por nombre, lugar, servicios...',
  'search.filters': 'Filtros',
};
